'use client'

import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { Typography } from '@acko/typography'
import { getInrFormat } from '@utils/inrFormatter'
import Image from 'next/image'
import styles from './page.module.css'

const imgCircleArrowLine = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Circle_arrow_line_882d3f586d.svg'
const imgCircleArrowFilled = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Circle_arrow_filled_9d8fd2ddfd.svg'

interface BikeContinueInsuringCardProps {
  commonSegmentEventProps: object
  item: any
}

export const BikeContinueInsuringCard = ({ commonSegmentEventProps, item }: BikeContinueInsuringCardProps) => {
  const vehicleName = [item?.mmv?.make, item?.mmv?.model].filter(Boolean).join(' ')
  const premium = getInrFormat(item?.net_premium, true)
  const vehicleType = item?.vehicle_type ?? 'bike'

  const handleClick = async () => {
    try {
      await trackEvent('tap_btn_CTA_widget', {
        ...commonSegmentEventProps,
        funnel: 'continue_entry',
        action_type: item?.is_renewal ? 'Renewal' : 'Continue',
      })
    } catch {
      // Analytics should not block continue-insuring navigation.
    }

    window.location.href = item.redirect_link
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      void handleClick()
    }
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className={`${styles.dsCard} group p-16 flex items-center gap-16 cursor-pointer`}
      data-bg="white"
      data-variant="outlined"
      onClick={() => {
        void handleClick()
      }}
      onKeyDown={handleKeyDown}>
      {item?.vehicle_image || item?.logo_url ? (
        <div className="shrink-0 w-56 h-56 rounded-[var(--radius-lg)] bg-[var(--color-surface-raised)] overflow-hidden flex items-center justify-center">
          <Image
            alt={vehicleName}
            className="w-full h-full object-contain"
            height={56}
            src={item.vehicle_image ?? item.logo_url}
            width={56}
          />
        </div>
      ) : null}
      <div className="flex flex-col gap-4 flex-1 min-w-0">
        {vehicleName || item?.reg_no ? (
          <Typography variant="body-sm" color="secondary" as="p">
            {vehicleName}
            {item?.reg_no ? ` • ${item.reg_no}` : ''}
          </Typography>
        ) : null}
        <Typography variant="heading-md" as="p" color="primary" className="[font-weight:var(--font-weight-semibold)]">
          Continue insuring your {vehicleType}
          {premium ? `, starting at ${premium}.` : '.'}
        </Typography>
      </div>
      <div className="relative w-24 h-24 shrink-0">
        <img
          alt=""
          className="w-24 h-24 object-contain transition-opacity duration-200 group-hover:opacity-0"
          src={imgCircleArrowLine}
        />
        <img
          alt=""
          className="absolute inset-0 w-24 h-24 object-contain transition-opacity duration-200 opacity-0 group-hover:opacity-100"
          src={imgCircleArrowFilled}
        />
      </div>
    </div>
  )
}
